import { createSelector } from 'reselect';

export const getPartners = state =>
  state.partners.referredPartners.index.referral_details;
export const getCurrentPage = state =>
  state.dashboard.referrals.partners.currentPage;

// const perPage = 10;
// const paginate = (list, page) =>
//   list.slice((page - 1) * perPage, page * perPage);

// export const getPaginatedPartners = createSelector(
//   getPartners,
//   getCurrentPage,
//   paginate
// );

const getMostRecent = partners => partners.slice(0, 5);

export const getMostRecentPartners = createSelector(getPartners, getMostRecent);
